import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop.jsx';
import About from './pages/About.jsx';
import BlogPost from './pages/BlogPost.jsx';
import Blogs from './pages/Blogs.jsx';
import ClientIntakeForm from './pages/ClientIntakeForm.jsx';
import Contact from './pages/Contact.jsx';
import Expertise from './pages/Expertise.jsx';
import EcommerceRetail from './pages/expertise/EcommerceRetail.jsx';
import EnterpriseSolutions from './pages/expertise/EnterpriseSolutions.jsx';
import FinancialServices from './pages/expertise/FinancialServices.jsx';
import Healthcare from './pages/expertise/Healthcare.jsx';
import LifeSciences from './pages/expertise/LifeSciences.jsx';
import Technology from './pages/expertise/Technology.jsx';
import Home from './pages/Home.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import Services from './pages/Services.jsx';
import TermsOfService from './pages/TermsOfService.jsx';
import apiService from './services/api.js';
import './styles/custom.css';

// Analytics wrapper component
function AnalyticsWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    apiService.trackPageView({
      page: location.pathname,
      title: document.title
    });
  }, [location]);

  return children;
}

function App() {
  return (
    <Router>
      <AnalyticsWrapper>
        <ScrollToTop />
        <div className="app">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/client-intake" element={<ClientIntakeForm />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/expertise" element={<Expertise />} />
            <Route path="/expertise/healthcare" element={<Healthcare />} />
            <Route path="/expertise/life-sciences" element={<LifeSciences />} />
            <Route path="/expertise/financial-services" element={<FinancialServices />} />
            <Route path="/expertise/technology" element={<Technology />} />
            <Route path="/expertise/enterprise-solutions" element={<EnterpriseSolutions />} />
            <Route path="/expertise/e-commerce-retail" element={<EcommerceRetail />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </div>
      </AnalyticsWrapper>
    </Router>
  );
}

export default App;
